import React, { useState, useEffect, useRef, useCallback } from "react";
import { Toast } from "primereact/toast";

import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Componente } from "./Componente";
import { Divider } from "primereact/divider";
import { getRespuestas } from "../service/Formulario";
import { useDispatch, useSelector } from "react-redux";
import { loading } from "../actions";
import { InputText } from "primereact/inputtext";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { cerrarFormulario } from "../service/OtroFormulario";

export const Formulario = ({ ini = 0, active = false, data = [], preguntas = [], label = "", id = null, final = false, editar = true, otroFormulario = false, cerrar = null , registroSet ,es_fudei = false}) => {
    
    const [visible, setVisible] = useState(false);
    const [of, setof] = useState(false);
    const [esFudei, setEsFudei] = useState(false);
    //  const data_  = useRef([]);
    const [data_, setData_] = useState([]);
    const [preguntas_, setPreguntas] = useState([]);
    const [editar_, setEditar_] = useState([]);
    const dataGuardar = useRef({});
    var dataGuardada = useRef({});
    const label_ = useRef("");
    const id_ = useRef(null);
    const toast = useRef(null);

    const final_ = useRef(final);

    const dispatch = useDispatch();

    const arrayRef = useRef({});

    const [ini_, setIni_] = useState(null);

    const { usuario } = useSelector((state) => ({
        usuario: state.usuario,
    }));

    if (ini !== ini_) {
        dataGuardar.current = {};
        arrayRef.current = {};
        dataGuardada.current = {};
        setIni_(ini);
    }

    const setRef = (name, obj) => {
        arrayRef.current[`${name}`] = obj;
    };

    const getRef = (name) => {
        return arrayRef.current[`${name}`];
    };

    const getRefFrm = () => {
        return arrayRef;
    };

    const getDataSave = (name, obj) => {

        let objP = { adicional: "", idpregunta: name, idrespuesta: obj.idrespuesta, respuesta: obj.respuesta };

        if (obj.ini) {
            let objPIni = { adicional: "", idpregunta: name, idrespuesta: obj.idrespuesta, respuesta: obj.respuesta };
            dataGuardada.current[`${name}`] = objPIni;
            //debugger;
        } else {
            //debugger;
            objP = dataGuardar.current[`${name}`];
            if (objP !== undefined) {
                objP.respuesta = obj.respuesta;
            } else {
                console.log("No existe valor para Guardarlo");
            }
        }

        dataGuardar.current[`${name}`] = objP;
    };

    const onSave = async () => {
        //debugger;
        /*
        console.log('----DATA A GUARDAR------')
        console.log(Object.keys(dataGuardar.current).length);
        console.log(dataGuardar.current)
        console.log(Object.keys(arrayRef.current).length);
        console.log(arrayRef.current)
        console.log('------------------------')
        */
       // return;

        if (JSON.stringify(dataGuardar.current) !== JSON.stringify(dataGuardada.current)) {
            dispatch(loading(true));
            var data = await getRespuestas(usuario.token, id_.current, dataGuardar.current);

            if (data.error == 0) {
                //  dataGuardada.current = data.resultado;
                registroSet(true);
                toast.current?.show({ severity: "success", summary: "OK", detail: "Registros Guardados", life: 8000 });

            } else {
                if (data.error == 1) {
                    toast.current?.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
                } else {
                    console.log("Error");
                }
            }
            dispatch(loading(false));
        }
    };

    useEffect(() => {
        setVisible(active);
        //debugger
        setof(otroFormulario);
        return () => {
            if (label_.current === label && active) {
                console.log("cleaned up: " + label);
                var ddrrrd = dataGuardar.current;
                onSave();
                //   toast.current.show({ severity: 'info', summary: 'Información: ', detail: JSON.stringify(dataGuardar.current), life: 3000 });
            }
        };
    }, [active]);

    useEffect(() => {
        //setData_(dass);
        setEditar_(editar);
        setData_(data);
        label_.current = label;
        id_.current = id;
        final_.current = final;
        setEsFudei(es_fudei)
/*
        console.log('----DATA A TTTT------')
        console.log(Object.keys(dataGuardar.current).length);
        console.log(dataGuardar.current)
        console.log(Object.keys(arrayRef.current).length);
        console.log(arrayRef.current)
        console.log('------------------------')
*/
    }, [data]);

    useEffect(() => {
        setPreguntas(preguntas);
    }, [preguntas]);


    const titlePagePaso = () => {
        return (
            <h5 className="p-col-12 p-m-1 p-p-1" style={{ color: "var(--primary-color)" }}>
                {label_.current}
            </h5>
        );
    };

    const confirmCerrar = () => {
        confirmDialog({
            message: "Estas seguro de cerrar el Formulario?",
            header: "Cerrar Confirmar",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-success",
            accept: () => cerrarOtroFormulario(),
        });
    };

    const cerrarOtroFormulario = async () => {
        dispatch(loading(true));

        var data = await cerrarFormulario(usuario.token, id_.current);
        if (data.error == 0) {
            cerrar();
        } else {
            if (data.error == 1) {
                toast.current?.show({ severity: "error", summary: "Error", detail: data.mensaje, life: 3000 });
            } else {
                console.log("Error");
            }
        }
        dispatch(loading(false));
    };

    return (
        <div>
            <Toast ref={toast} />
            <div style={{ display: visible ? "block" : "none" }}>
                <div className="p-grid table-demo p-fluid p-mm-0">
                    <div className="p-col-12" style={{ borderColor: "black", border: "solid", backgroundColor: !esFudei?(of ? "#f9bf8f" : "#9bbb59"):'', fontWeight: "bold", borderWidth: "1px", padding: "3px" }}>
                        {" "}
                        {label_.current}
                    </div>

                    {preguntas_?.map((pregunta, index) => {

                        return (
                            <Componente
                                key={index}
                                obj={pregunta}
                                label={pregunta.label}
                                tipo={pregunta.tipo}
                                size={pregunta.size}
                                value={pregunta.value}
                                name={pregunta.id}
                                opciones={pregunta.opciones}
                                readonly={editar_ ? pregunta.readonly : true}
                                getDataSave={getDataSave}
                                setRef={setRef}
                                getRef={getRef}
                                getRefFrm={getRefFrm}
                            />
                        );
                    })}

                    {data_?.map((grupo, index1) => {
                        let title1 =
                            grupo.grupo === null || grupo.grupo === "" ? (
                                ""
                            ) : (
                                <div className="p-col-12 p-mt-1 p-pl-3" style={{ borderColor: "black", border: "solid", backgroundColor: !esFudei?(of ? "#f9bf8ff5" : "#c2d69b"):'', fontWeight: "bold", borderWidth: "1px", padding: "2px", marginTop: "-1px" }}>
                                    {grupo.grupo}
                                </div>
                            );

                        let detallePreguntas1 = grupo.preguntas?.map((pregunta, index100) => {
                            return (
                                <Componente
                                    key={index100}
                                    obj={pregunta}
                                    label={pregunta.label}
                                    tipo={pregunta.tipo}
                                    size={pregunta.size}
                                    value={pregunta.value}
                                    name={pregunta.id}
                                    opciones={pregunta.opciones}
                                    readonly={editar_ ? pregunta.readonly : true}
                                    getDataSave={getDataSave}
                                    setRef={setRef}
                                    getRef={getRef}
                                    getRefFrm={getRefFrm}
                                />
                            );
                        });

                        let detalleGrupo1 = grupo.grupo_hijos?.map((grupo100, index100) => {
                            let title2 =
                                grupo100.grupo === null || grupo100.grupo === "" ? (
                                    ""
                                ) : (
                                    <div className="p-col-12 p-pl-5" style={{ borderColor: "black", border: "solid", backgroundColor: !esFudei?(of ? "#f9bf8feb" : "#d6e3bc"):'#007bff', fontWeight: "bold", borderWidth: "1px", padding: "2px", marginTop: "-1px" }}>
                                        {grupo100.grupo}
                                    </div>
                                );

                            let detallePreguntas2 = grupo100.preguntas?.map((pregunta, index200) => {
                                return (
                                    <Componente
                                        key={index200}
                                        obj={pregunta}
                                        label={pregunta.label}
                                        tipo={pregunta.tipo}
                                        size={pregunta.size}
                                        value={pregunta.value}
                                        name={pregunta.id}
                                        opciones={pregunta.opciones}
                                        readonly={editar_ ? pregunta.readonly : true}
                                        getDataSave={getDataSave}
                                        setRef={setRef}
                                        getRef={getRef}
                                        getRefFrm={getRefFrm}
                                    />
                                );
                            });

                            let detalleGrupo2 = grupo100.grupo_hijos?.map((grupo200, index200) => {
                                let title3 =
                                    grupo200.grupo === null || grupo200.grupo === "" ? (
                                        ""
                                    ) : (
                                        <div className="p-col-12 p-pl-6" style={{ borderColor: "black", border: "solid", backgroundColor: !esFudei?(of ? "#f9bf8fe0" : "#eaf1dd"):'', fontWeight: "bold", borderWidth: "1px", padding: "2px", marginTop: "-1px" }}>
                                            {grupo200.grupo}
                                        </div>
                                    );

                                let detallePreguntas3 = grupo200.preguntas?.map((pregunta, index300) => {
                                    return (
                                        <Componente
                                            key={index300}
                                            obj={pregunta}
                                            label={pregunta.label}
                                            tipo={pregunta.tipo}
                                            size={pregunta.size}
                                            value={pregunta.value}
                                            name={pregunta.id}
                                            opciones={pregunta.opciones}
                                            readonly={editar_ ? pregunta.readonly : true}
                                            getDataSave={getDataSave}
                                            setRef={setRef}
                                            getRef={getRef}
                                            getRefFrm={getRefFrm}
                                        />
                                    );
                                });

                                let detalleGrupo3 = grupo200.grupo_hijos?.map((grupo300, index300) => {
                                    let title4 =
                                        grupo300.grupo === null || grupo300.grupo === "" ? (
                                            ""
                                        ) : (
                                            <div className="p-col-12 p-pl-6" style={{ borderColor: "black", border: "solid", backgroundColor: "#eaf1dd", fontWeight: "bold", borderWidth: "1px", padding: "2px", marginTop: "-1px" }}>
                                                {grupo300.grupo}
                                            </div>
                                        );

                                    let detallePreguntas4 = grupo300.preguntas?.map((pregunta, index400) => {
                                        return (
                                            <Componente
                                                key={index400}
                                                obj={pregunta}
                                                label={pregunta.label}
                                                tipo={pregunta.tipo}
                                                size={pregunta.size}
                                                value={pregunta.value}
                                                name={pregunta.id}
                                                opciones={pregunta.opciones}
                                                readonly={editar_ ? pregunta.readonly : true}
                                                getDataSave={getDataSave}
                                                setRef={setRef}
                                                getRef={getRef}
                                                getRefFrm={getRefFrm}
                                            />
                                        );
                                    });

                                    let detalleGrupo4 = grupo300.grupo_hijos?.map((pregunta, index400) => {
                                        return (
                                            <Componente
                                                key={index400}
                                                obj={pregunta}
                                                label={pregunta.label}
                                                tipo={pregunta.tipo}
                                                size={pregunta.size}
                                                value={pregunta.value}
                                                name={pregunta.id}
                                                opciones={pregunta.opciones}
                                                readonly={editar_ ? pregunta.readonly : true}
                                                getDataSave={getDataSave}
                                                setRef={setRef}
                                                getRef={getRef}
                                                getRefFrm={getRefFrm}
                                            />
                                        );
                                    });
                                    return (
                                        <React.Fragment key={index300}>
                                            {title4}
                                            {detallePreguntas4}
                                            {detalleGrupo4}
                                        </React.Fragment>
                                    );
                                });
                                return (
                                    <React.Fragment key={index200}>
                                        {title3}
                                        {detallePreguntas3}
                                        {detalleGrupo3}
                                    </React.Fragment>
                                );
                            });

                            return (
                                <React.Fragment key={index100}>
                                    {title2}
                                    {detallePreguntas2}
                                    {detalleGrupo2}
                                </React.Fragment>
                            );
                        });

                        return (
                            <React.Fragment key={index1}>
                                {title1}
                                {detallePreguntas1}
                                {detalleGrupo1}
                            </React.Fragment>
                        );
                    })}
                </div>

                <div className="p-grid p-justify-end p-mr-3 p-mt-2">
                    {editar_ ? <Button label="Registrar" icon="pi pi-check" onClick={() => onSave()} /> : ""}
                    {editar_  && final_.current ? (of? <Button style={{marginLeft:'10px'}}label= "Finalizar" icon="pi pi-lock" onClick={() => confirmCerrar()} />:"" ) : ""}
                </div>
            </div>
        </div>
    );
};
